// src/auth/AdminRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

const AdminRoute = () => {
  const { userRole, loadingAuth } = useAuth();

  if (loadingAuth) {
    return <div>Carregando...</div>; // Ou um componente de spinner
  }

  // Se o usuário tem a função 'admin', permite o acesso.
  // Senão, redireciona para a página principal do PDV.
  return userRole === 'admin' ? <Outlet /> : <Navigate to="/pdv" replace />;
};

export default AdminRoute;